import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    signal,
    ViewChild,
} from '@angular/core';
import {
    NgbTypeahead,
    NgbTypeaheadModule,
    NgbTypeaheadSelectItemEvent,
} from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
} from 'rxjs/operators';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'telxl-shared-type-ahead-focus-search',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgbTypeaheadModule, FormsModule],
    templateUrl: './type-ahead-focus-search.component.html',
    styleUrl: './type-ahead-focus-search.component.scss',
})
export class TelxlTypeAheadFocusSearchComponent {
    model: unknown;
    placeholder = input<string>('');
    label = input<string>('');
    showLabel = input<boolean>(false);
    dataSource = input<string[]>([]);
    isFocused = signal(false);
    modelOutput = output<string>();
    selectedOutput = output<string>();
    formatter = (result: string) => result;

    @ViewChild('instance', { static: true }) instance!: NgbTypeahead;

    focus$ = new Subject<string>();
    click$ = new Subject<string>();

    modelChanged(searchResult: string) {
        this.modelOutput.emit(searchResult);
    }

    selectedItem(selected: NgbTypeaheadSelectItemEvent) {
        selected.preventDefault();
        this.selectedOutput.emit(selected.item);
    }

    search: OperatorFunction<string, readonly string[]> = (
        text$: Observable<string>,
    ) => {
        const debouncedText$ = text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
        );
        const clicksWithClosedPopup$ = this.click$.pipe(
            filter(() => !this.instance.isPopupOpen()),
        );
        const inputFocus$ = this.focus$;

        return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
            map(term =>
                (term === ''
                    ? this.dataSource()
                    : this.dataSource().filter(
                          v => v.toLowerCase().indexOf(term.toLowerCase()) > -1,
                      )
                ).slice(0, 10),
            ),
        );
    };
}
